import { FormField } from 'ui/formField';
import { spacing } from 'ui/theme';
import { Toggle } from 'ui/toggle';
import noop from 'utils/noop';
import * as campaignColumns from '../../components/dashboardWidget/widgets/campaignColumns';

// type Props = {
//   columns: {},
//   /** Callback function when value is changed. */
//   onChange: () => void,
//   /** Value of the trendDirection */
//   value: [],
// };

export const CampaignColumns = ({ columns = campaignColumns, onChange = noop, value = [] }) => {
  /**
   * handleChange
   * @param { boolean } isActive: The new active state of the toggle.
   * @param { string } checkboxValue: The value of the changed toggle.
   * @returns { void }
   */
  const handleChange = (isActive, checkboxValue) => {
    let newValues = value;
    if (isActive) {
      newValues = [...newValues, checkboxValue];
    } else {
      newValues = value.filter((val) => val !== checkboxValue);
    }
    onChange(null, { value: newValues });
  };

  return (
    <FormField>
      {Object.keys(columns).map((column) => {
        const { name: columnName, value: columnValue } = columns[column];
        const toggleId = `${columnValue}-toggle`;
        const labelId = `${columnValue}-label`;
        return (
          <div
            key={toggleId}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: spacing.half,
              margin: `${spacing.base} 0`,
            }}
          >
            <Toggle
              id={toggleId}
              isActive={value.indexOf(columnValue) !== -1}
              isDisabled={columnValue === columns.NAME.value}
              labelId={labelId}
              onClick={(isActive) => handleChange(isActive, columnValue)}
            />
            <label htmlFor={toggleId} id={labelId} style={{ margin: 0, cursor: 'pointer' }}>
              {columnName}
            </label>
          </div>
        );
      })}
    </FormField>
  );
};
